
<template>
  <svg :class="[
      'svg-icon',
      shit$(`pointer-events: none; vertical-align: middle; display: inline-block`),
      shit$(`fill:${ color || '#c1c1c1' }; stroke: ${ stroke || '' };`),
      active && shit$(`fill:#00b5e2; stroke:#00b5e2;`),
      shit && shit$(shit)
    ]" :width="width" :height="height">
      <use :xlink:href="href"></use>
  </svg>
</template>
<script>
export default {
  name: "svg-icon",
  props: {
      href: String,
      shit: String,
      width: [Number,String],
      color: String,
      height: [Number,String],
      active: Boolean,
      stroke: String
  },
};
</script>